export default "__VITE_ASSET__CbDIHH01__"